import { useMemo } from 'react';
import { Tabs, Tab } from '@mui/material';
import { TabsHeader } from '../../components/tabs/TabsHeader';
import { TabsBody } from '../../components/tabs/TabsBody';
import { useContext } from './context';
import { FieldsTab } from './FieldsTab';
import { InstancesTab } from './InstancesTab';

const tabStyle = { minWidth: 80 };

export function LpkTabs(props) {
  const { renderSidePanel } = props;
  const { tab, setTab } = useContext();

  const tabs = useMemo(
    () => (
      <TabsHeader>
        <Tabs value={tab} onChange={(e, selectedTab) => setTab(selectedTab)}>
          <Tab sx={tabStyle} label="L" value="L" />
          <Tab sx={tabStyle} label="P" value="P" />
          <Tab sx={tabStyle} label="K" value="K" />
          <Tab sx={tabStyle} label="Instances" value="instances" />
        </Tabs>
      </TabsHeader>
    ),
    [setTab, tab],
  );

  return (
    <TabsBody>
      <FieldsTab type="L" tabs={tabs} renderSidePanel={renderSidePanel} />
      <FieldsTab type="P" tabs={tabs} renderSidePanel={renderSidePanel} />
      <FieldsTab type="K" tabs={tabs} renderSidePanel={renderSidePanel} />
      <InstancesTab tabs={tabs} renderSidePanel={renderSidePanel} />
    </TabsBody>
  );
}
